import { ReactElement } from 'react';

import { Badge } from 'components/elements/badge/badge';
import { BadgeType } from 'components/elements/badge/types';
import IconChecked from 'components/icons/checked';
import IconCross from 'components/icons/cross';
import IconDash from 'components/icons/dash';
import IconRefresh from 'components/icons/refresh';

import { PaymentProviderStatus } from 'types/pwcOrder';

import { badgePropsMap } from './keys';
import { BadgeContent } from './styles';

interface StatusBadgeProps {
  status: PaymentProviderStatus;
}

const badgeToIconMap: Record<PaymentProviderStatus, ReactElement | null> = {
  [PaymentProviderStatus.PENDING]: <IconRefresh />,
  [PaymentProviderStatus.SUCCEEDED]: <IconChecked />,
  [PaymentProviderStatus.FAILED]: <IconCross />,
};

const badgeTypeMap: Record<PaymentProviderStatus, BadgeType> = {
  [PaymentProviderStatus.PENDING]: BadgeType.Default,
  [PaymentProviderStatus.SUCCEEDED]: BadgeType.Success,
  [PaymentProviderStatus.FAILED]: BadgeType.Fail,
};

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const { type, label } = badgePropsMap[status] || badgePropsMap[PaymentProviderStatus.PENDING];
  const icon = badgeToIconMap[type];
  const badgeType = badgeTypeMap[type];

  const usedLabel = label || <IconDash />;

  return (
    <Badge type={badgeType}>
      <BadgeContent>
        {icon}
        {usedLabel}
      </BadgeContent>
    </Badge>
  );
};
